import { render } from "./AnamneseSection.vue?vue&type=template&id=70417f93&scoped=true"
import script from "./AnamneseSection.vue?vue&type=script&lang=js"
export * from "./AnamneseSection.vue?vue&type=script&lang=js"

import "./AnamneseSection.vue?vue&type=style&index=0&id=70417f93&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70417f93"]])

export default __exports__